import React from 'react'
import './post.css'

function Post({post}) {    
    return ( 
        <div className="post">            
            <h2 className="post-title">{post.title}</h2>              
            <div className="post-info">
                <span>By: {post.username}</span>
                <span>{new Date(post.createdAt).toLocaleDateString()}</span>
            </div>
            <p className="post-desc">                
                    {post.desc}                
            </p>
            <ul className="post-tags">
                <li className="post-tag-item">{post.categories}</li>
                      
            </ul>
        </div>
    )
}

export default Post
